import { render, staticRenderFns } from "./arbitrage-transaction-details.vue?vue&type=template&id=2dcf1e82&"
import script from "./arbitrage-transaction-details.vue?vue&type=script&lang=js&"
export * from "./arbitrage-transaction-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports